<template>
  <div class="text-black">
    <h1 class="text-xl font-semibold bg-beige-academy-300 text-white text-center p-6">
      {{notification.message}}
    </h1>
    <div class="flex flex-col md:flex-row justify-between items-center w-full text-center
    px-6 text-lg">
      <div class="flex flex-col text-md mt-10 mb-4 w-1/2">
        <h2 class="mb-6"> {{ $t('lesson.original') }} </h2>
        <div class="mb-2" v-if="oldSlot.start">
          <strong >
            {{ getDayFormat(oldSlot.day) }}</strong>
        </div>
        <strong class="mb-2" v-if="oldSlot.start">
            {{ oldSlot.start }} - {{ oldSlot.end }}
        </strong>
      </div>
      <div class="flex flex-col text-md mt-10 mb-4 w-1/2">
        <h2 class="mb-6">{{ $t('lesson.newProposed') }}</h2>
        <div class="mb-2" v-if="oldSlot.start">
          <strong >
            {{ getDayFormat(newSlot.day) }}</strong>
        </div>
        <strong class="mb-2" v-if="oldSlot.start">
            {{ newSlot.start }} - {{ newSlot.end }}
        </strong>
      </div>
    </div>
    <div class="flex flex-row justify-between my-2 text-sm md:w-5/6 w-full mx-auto p-6">
      <button
        @click="rejectNewLessonTime"
        class="px-4 py-3 rounded border bg-orange-academy-300 border-orange-academy-300 uppercase
        hover:bg-white text-white hover:text-orange-academy-300 font-bold cursor-pointer mb-3
        mr-4 md:mr-0">
          {{ $t('lesson.reject') }}
      </button>
      <button
        @click="acceptNewLessonTime"
        class="px-4 py-3 rounded border bg-orange-academy-300 border-orange-academy-300 uppercase
        hover:bg-white text-white hover:text-orange-academy-300 font-bold cursor-pointer mb-3">
          {{ $t('lesson.accept') }}
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import dayjs from 'dayjs';
import StreamFunctionsMixin from '@/mixins/StreamFunctionsMixin';
import ModalsMixin from '@/mixins/ModalsMixin';

export default {
  props: ['notification'],

  data() {
    return {
      oldSlot: {},
      newSlot: {},
    };
  },

  mixins: [StreamFunctionsMixin, ModalsMixin],

  created() {
    this.getSlots();
  },

  methods: {
    getSlots() {
      const ids = JSON.parse(this.notification.description);
      axios.get(`/api/slots/${ids.id_old}`).then((response) => {
        this.oldSlot = this.convertSlotToBeDisplaied(response.data);
      }).catch(() => {
        this.createNotification('error', this.$t('notifications.errorReload'));
      });
      axios.get(`/api/slots/${ids.id_new}`).then((response) => {
        this.newSlot = this.convertSlotToBeDisplaied(response.data);
      }).catch(() => {
        this.createNotification('error', this.$t('notifications.errorReload'));
      });
    },

    acceptNewLessonTime() {
      axios.put(`/api/slots/pending/${this.newSlot.id}?accepted=true`, { oldSlot: this.oldSlot }).then(() => {
        this.createNotification('success', this.$t('notifications.answerSentToTeacher'));
        this.$modal.hide('notification');
      }).catch(() => {
        this.createNotification('error', this.$t('notifications.errorTryAgain'));
      });
    },

    rejectNewLessonTime() {
      axios.put(`/api/slots/pending/${this.newSlot.id}?accepted=false`, { oldSlot: this.oldSlot }).then(() => {
        this.createNotification('success', this.$t('notifications.answerSentToTeacher'));
        this.$modal.hide('notification');
      }).catch(() => {
        this.createNotification('error', this.$t('notifications.errorTryAgain'));
      });
    },

    getDayFormat(day) {
      return dayjs.tz(day).format('LL');
    },
  },
};
</script>
